import { pBase } from './.catalog';

export default class pOturumAc extends pBase {
  constructor(options: { KullaniciAdi?: string; Sifre?: string; Ticket?: boolean | undefined }) {
    super();
    this.KullaniciAdi = options.KullaniciAdi;
    this.Sifre = options.Sifre;
    this.Ticket = options.Ticket;
  }

  public KullaniciAdi: string | undefined;
  public Sifre: string | undefined;
  public Ticket?: boolean | undefined;
}
